import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

import { FuseSidebarService } from '../../../@fuse/components/sidebar/sidebar.service';

export const PRODUCT_UPSELL_PANEL_NAME = 'productUpsellPanel';

export interface ProductUpsellPanelData {
  shopUuid: string;
  shopName?: string;
  productUuid: string;
  productName?: string;
}

/**
 * Fiche produit — side panel des suggestions (upsell CEL, flux 1-à-N par
 * produit/boutique). Même contrat que UpsaleQuestionsPanelService : open()
 * résout une seule fois ; le résultat est la réponse du PUT upsert
 * (falsy = fermé sans sauvegarde).
 */
@Injectable({ providedIn: 'root' })
export class ProductUpsellPanelService {
  private _result$: Subject<any | false> | null = null;
  private readonly _isOpen$ = new BehaviorSubject<boolean>(false);
  private _data: ProductUpsellPanelData | null = null;

  readonly isOpen$ = this._isOpen$.asObservable();

  constructor(private _fuseSidebarService: FuseSidebarService) {}

  open(data: ProductUpsellPanelData): Observable<any | false> {
    if (this._result$) {
      this._result$.complete();
    }
    this._result$ = new Subject<any | false>();
    this._data = data;

    this._isOpen$.next(true);
    setTimeout(() => {
      this._fuseSidebarService.getSidebar(PRODUCT_UPSELL_PANEL_NAME)?.open();
    });

    return this._result$.asObservable().pipe(take(1));
  }

  getData(): ProductUpsellPanelData | null {
    return this._data;
  }

  emitResult(result: any | false): void {
    this._fuseSidebarService.getSidebar(PRODUCT_UPSELL_PANEL_NAME)?.close();

    this._result$?.next(result);
    this._result$?.complete();
    this._result$ = null;
    this._data = null;
    this._isOpen$.next(false);
  }
}
